module.exports = __webpack_public_path__ + "static/media/import_info.108c157d.svg";